import BackofficeIndexBase from './BackofficeIndexBase.js';
import Rails from '@rails/ujs';

export default class BackofficeOrdersIndex extends BackofficeIndexBase {
  constructor() {
    super("#orders-datatable", {
      savedFiltersBannerId: 'order-saved-filters-banner'
    });

    this.bindEvents();
  }

  bindEvents() {
    this.bindSaveStepButton();
    this.bindExportGlobalExcel();
    this.bindStepDropdown('order_step', '#orders-datatable', '#orders-loader');
    this.bindFilterForm('#orders-loader');
    this.bindSaveFiltersButton('save-order-filters', 'clear-order-filters');
    this.bindClearFiltersButton('clear-order-filters');
  }

  bindExportGlobalExcel() {
    const $exportButton = $('#export-global-excel');
    if ($exportButton.length === 0) {
      return;
    }

    $exportButton.on('click', (event) => {
      event.preventDefault();

      const url = $exportButton.data('url');

      application.openLoader();

      const xhr = new XMLHttpRequest();
      xhr.open('GET', url, true);
      xhr.responseType = 'blob';
      xhr.setRequestHeader('X-CSRF-Token', Rails.csrfToken());

      xhr.onload = () => {
        if (xhr.status >= 200 && xhr.status < 300) {
          application.closeLoader();

          const currentDate = new Date().toLocaleDateString('fr-FR').replaceAll('/', '');
          const fileName = `orders_global_export_${currentDate}.xlsx`;

          const blobUrl = globalThis.URL.createObjectURL(xhr.response);
          const $link = $('<a>', {
            href: blobUrl,
            download: fileName,
            css: { display: 'none' }
          }).appendTo('body');

          $link[0].click();

          globalThis.URL.revokeObjectURL(blobUrl);
          $link.remove();
        } else {
          application.closeLoader();
          application.errorNotification("Erreur lors de l'export global Excel");
        }
      };

      xhr.onerror = () => {
        application.closeLoader();
        application.errorNotification("Erreur lors de l'export global Excel");
      };

      xhr.send();
    });
  }

  onDataChanged() {
    // Custom logic for orders
  }
}